import React from "react"
import { Badge, Button, Card, CardBody, Table } from "reactstrap"
import { OrderArrows, TierSelect } from "components/Common/SponsorBand/RowControls"
import { PARTNER_TIERS, marketLabel } from "./partnerPayload"
import { daysLeft, isExpiring, isLimited } from "./bandLayout"

// The data the band cannot carry: who is limited to one market, whose contract runs out and when.
//
// It is also the keyboard path to arranging the band (the shared row controls): the tier select
// re-tiers, the arrows reorder.

const ContractsTable = ({ partners, now, onEdit, onRetier, onShift }) => (
  <Card className="mb-3">
    <CardBody>
      <h6 className="mb-2">Contracts and markets</h6>
      <p className="text-muted" style={{ fontSize: 13 }}>
        Everything currently on the band. The tier and the arrows move a partner without dragging.
      </p>

      {partners.length === 0 ? (
        <p className="text-muted mb-0">
          Nothing on the band yet. Add a partner from any tier above.
        </p>
      ) : (
        <Table responsive className="align-middle mb-0">
          <thead>
            <tr style={{ fontSize: 12 }}>
              <th>Partner</th>
              <th>Tier</th>
              <th>Order</th>
              <th>Markets</th>
              <th>Contract ends</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {partners.map((partner, index) => {
              const first = index === 0 || partners[index - 1].tier !== partner.tier
              const last = index === partners.length - 1 || partners[index + 1].tier !== partner.tier

              return (
                <tr key={partner.id} style={{ fontSize: 13 }}>
                  <td style={{ fontWeight: 600 }}>
                    {partner.name}
                    {partner.url && (
                      <div className="text-muted" style={{ fontSize: 12, fontWeight: 400 }}>
                        {partner.url}
                      </div>
                    )}
                  </td>
                  <td>
                    <TierSelect
                      row={partner}
                      tiers={PARTNER_TIERS}
                      value={partner.tier}
                      onRetier={onRetier}
                    />
                  </td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <OrderArrows row={partner} first={first} last={last} onShift={onShift} />
                  </td>
                  <td>
                    {isLimited(partner) ? (
                      <Badge color="info" pill>
                        {marketLabel(partner.countries)}
                      </Badge>
                    ) : (
                      <span className="text-muted">all markets</span>
                    )}
                  </td>
                  <td>
                    {partner.endsAt ? (
                      <span className={isExpiring(partner, now) ? "text-danger" : ""}>
                        {String(partner.endsAt).slice(0, 10)}
                        {isExpiring(partner, now) && ` · ${daysLeft(partner.endsAt, now)} days`}
                      </span>
                    ) : (
                      <span className="text-muted">open-ended</span>
                    )}
                  </td>
                  <td>
                    <Badge color="success" pill>
                      on the band
                    </Badge>
                  </td>
                  <td className="text-right">
                    <Button size="sm" color="link" onClick={() => onEdit(partner)}>
                      Edit
                    </Button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      )}
    </CardBody>
  </Card>
)

export default ContractsTable
